var cov_10sngc5gms = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/FilterList.tsx",
      hash = "155e28f4a70d80d169537de95709ac86739229fb",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/FilterList.tsx",
    statementMap: {
      "0": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 16
        }
      },
      "1": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 52
        }
      },
      "2": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 15,
          column: 60
        }
      },
      "3": {
        start: {
          line: 19,
          column: 22
        },
        end: {
          line: 19,
          column: 32
        }
      },
      "4": {
        start: {
          line: 20,
          column: 16
        },
        end: {
          line: 20,
          column: 34
        }
      },
      "5": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 32
        }
      },
      "6": {
        start: {
          line: 25,
          column: 87
        },
        end: {
          line: 25,
          column: 97
        }
      },
      "7": {
        start: {
          line: 26,
          column: 20
        },
        end: {
          line: 26,
          column: 53
        }
      },
      "8": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 27,
          column: 39
        }
      },
      "9": {
        start: {
          line: 27,
          column: 33
        },
        end: {
          line: 27,
          column: 39
        }
      },
      "10": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 28,
          column: 30
        }
      },
      "11": {
        start: {
          line: 28,
          column: 11
        },
        end: {
          line: 28,
          column: 30
        }
      },
      "12": {
        start: {
          line: 29,
          column: 17
        },
        end: {
          line: 29,
          column: 40
        }
      },
      "13": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "14": {
        start: {
          line: 30,
          column: 34
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "15": {
        start: {
          line: 31,
          column: 17
        },
        end: {
          line: 31,
          column: 85
        }
      },
      "16": {
        start: {
          line: 31,
          column: 64
        },
        end: {
          line: 31,
          column: 79
        }
      },
      "17": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 32,
          column: 32
        }
      },
      "18": {
        start: {
          line: 32,
          column: 18
        },
        end: {
          line: 32,
          column: 32
        }
      },
      "19": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 85
        }
      },
      "20": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "21": {
        start: {
          line: 34,
          column: 32
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "22": {
        start: {
          line: 38,
          column: 21
        },
        end: {
          line: 38,
          column: 31
        }
      },
      "23": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 43
        }
      },
      "24": {
        start: {
          line: 43,
          column: 27
        },
        end: {
          line: 43,
          column: 37
        }
      },
      "25": {
        start: {
          line: 44,
          column: 17
        },
        end: {
          line: 44,
          column: 27
        }
      },
      "26": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 48,
          column: 5
        }
      },
      "27": {
        start: {
          line: 46,
          column: 25
        },
        end: {
          line: 46,
          column: 31
        }
      },
      "28": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 59
        }
      },
      "29": {
        start: {
          line: 47,
          column: 20
        },
        end: {
          line: 47,
          column: 59
        }
      },
      "30": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 23
        }
      },
      "31": {
        start: {
          line: 53,
          column: 21
        },
        end: {
          line: 53,
          column: 31
        }
      },
      "32": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 75,
          column: 5
        }
      },
      "33": {
        start: {
          line: 58,
          column: 12
        },
        end: {
          line: 64,
          column: 18
        }
      },
      "34": {
        start: {
          line: 66,
          column: 10
        },
        end: {
          line: 66,
          column: 37
        }
      },
      "35": {
        start: {
          line: 66,
          column: 23
        },
        end: {
          line: 66,
          column: 37
        }
      },
      "36": {
        start: {
          line: 67,
          column: 10
        },
        end: {
          line: 72,
          column: 11
        }
      },
      "37": {
        start: {
          line: 82,
          column: 22
        },
        end: {
          line: 82,
          column: 32
        }
      },
      "38": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 83,
          column: 51
        }
      },
      "39": {
        start: {
          line: 83,
          column: 25
        },
        end: {
          line: 83,
          column: 40
        }
      },
      "40": {
        start: {
          line: 87,
          column: 33
        },
        end: {
          line: 87,
          column: 43
        }
      },
      "41": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 71
        }
      },
      "42": {
        start: {
          line: 88,
          column: 30
        },
        end: {
          line: 88,
          column: 70
        }
      },
      "43": {
        start: {
          line: 88,
          column: 47
        },
        end: {
          line: 88,
          column: 69
        }
      },
      "44": {
        start: {
          line: 92,
          column: 73
        },
        end: {
          line: 92,
          column: 83
        }
      },
      "45": {
        start: {
          line: 93,
          column: 15
        },
        end: {
          line: 93,
          column: 60
        }
      },
      "46": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "47": {
        start: {
          line: 96,
          column: 6
        },
        end: {
          line: 96,
          column: 36
        }
      },
      "48": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 108,
          column: 5
        }
      },
      "49": {
        start: {
          line: 105,
          column: 27
        },
        end: {
          line: 105,
          column: 89
        }
      },
      "50": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 18
        }
      },
      "51": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 134,
          column: 27
        }
      },
      "52": {
        start: {
          line: 134,
          column: 16
        },
        end: {
          line: 134,
          column: 27
        }
      },
      "53": {
        start: {
          line: 135,
          column: 17
        },
        end: {
          line: 135,
          column: 34
        }
      },
      "54": {
        start: {
          line: 136,
          column: 4
        },
        end: {
          line: 144,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 51
          },
          end: {
            line: 16,
            column: 3
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 18,
            column: 3
          }
        },
        loc: {
          start: {
            line: 18,
            column: 32
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 18
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        loc: {
          start: {
            line: 24,
            column: 50
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 47
          },
          end: {
            line: 31,
            column: 48
          }
        },
        loc: {
          start: {
            line: 31,
            column: 64
          },
          end: {
            line: 31,
            column: 79
          }
        },
        line: 31
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 17
          },
          end: {
            line: 40,
            column: 3
          }
        },
        line: 37
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 42,
            column: 2
          },
          end: {
            line: 42,
            column: 3
          }
        },
        loc: {
          start: {
            line: 42,
            column: 29
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 42
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 47,
            column: 16
          }
        },
        loc: {
          start: {
            line: 47,
            column: 20
          },
          end: {
            line: 47,
            column: 59
          }
        },
        line: 47
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 11
          },
          end: {
            line: 76,
            column: 3
          }
        },
        line: 52
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 56,
            column: 19
          },
          end: {
            line: 56,
            column: 20
          }
        },
        loc: {
          start: {
            line: 56,
            column: 32
          },
          end: {
            line: 73,
            column: 9
          }
        },
        line: 56
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 81,
            column: 2
          },
          end: {
            line: 81,
            column: 3
          }
        },
        loc: {
          start: {
            line: 81,
            column: 20
          },
          end: {
            line: 84,
            column: 3
          }
        },
        line: 81
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 83,
            column: 20
          },
          end: {
            line: 83,
            column: 21
          }
        },
        loc: {
          start: {
            line: 83,
            column: 25
          },
          end: {
            line: 83,
            column: 40
          }
        },
        line: 83
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 3
          }
        },
        loc: {
          start: {
            line: 86,
            column: 28
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 86
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 88,
            column: 23
          },
          end: {
            line: 88,
            column: 24
          }
        },
        loc: {
          start: {
            line: 88,
            column: 30
          },
          end: {
            line: 88,
            column: 70
          }
        },
        line: 88
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 88,
            column: 39
          },
          end: {
            line: 88,
            column: 40
          }
        },
        loc: {
          start: {
            line: 88,
            column: 47
          },
          end: {
            line: 88,
            column: 69
          }
        },
        line: 88
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 3
          }
        },
        loc: {
          start: {
            line: 91,
            column: 15
          },
          end: {
            line: 109,
            column: 3
          }
        },
        line: 91
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 105,
            column: 19
          },
          end: {
            line: 105,
            column: 20
          }
        },
        loc: {
          start: {
            line: 105,
            column: 27
          },
          end: {
            line: 105,
            column: 89
          }
        },
        line: 105
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        loc: {
          start: {
            line: 111,
            column: 11
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 111
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 26,
            column: 20
          },
          end: {
            line: 26,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 20
          },
          end: {
            line: 26,
            column: 24
          }
        }, {
          start: {
            line: 26,
            column: 28
          },
          end: {
            line: 26,
            column: 53
          }
        }],
        line: 26
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 39
          }
        }, {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 27,
            column: 39
          }
        }],
        line: 27
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 27,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 27,
            column: 19
          }
        }, {
          start: {
            line: 27,
            column: 23
          },
          end: {
            line: 27,
            column: 31
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 30
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 30
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 30
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 40
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 40
          }
        }],
        line: 30
      },
      "5": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 32
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 32
          }
        }],
        line: 32
      },
      "6": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 44
          }
        }, {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 44
          }
        }],
        line: 34
      },
      "7": {
        loc: {
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 8
          },
          end: {
            line: 34,
            column: 16
          }
        }, {
          start: {
            line: 34,
            column: 20
          },
          end: {
            line: 34,
            column: 30
          }
        }],
        line: 34
      },
      "8": {
        loc: {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        }],
        line: 45
      },
      "9": {
        loc: {
          start: {
            line: 61,
            column: 62
          },
          end: {
            line: 61,
            column: 100
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 62
          },
          end: {
            line: 61,
            column: 86
          }
        }, {
          start: {
            line: 61,
            column: 90
          },
          end: {
            line: 61,
            column: 100
          }
        }],
        line: 61
      },
      "10": {
        loc: {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 37
          }
        }, {
          start: {
            line: 66,
            column: 10
          },
          end: {
            line: 66,
            column: 37
          }
        }],
        line: 66
      },
      "11": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 97,
            column: 5
          }
        }],
        line: 95
      },
      "12": {
        loc: {
          start: {
            line: 100,
            column: 9
          },
          end: {
            line: 106,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 10
          },
          end: {
            line: 103,
            column: 16
          }
        }, {
          start: {
            line: 105,
            column: 10
          },
          end: {
            line: 105,
            column: 90
          }
        }],
        line: 100
      },
      "13": {
        loc: {
          start: {
            line: 102,
            column: 13
          },
          end: {
            line: 102,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 102,
            column: 44
          },
          end: {
            line: 102,
            column: 62
          }
        }, {
          start: {
            line: 102,
            column: 65
          },
          end: {
            line: 102,
            column: 72
          }
        }],
        line: 102
      },
      "14": {
        loc: {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 27
          }
        }, {
          start: {
            line: 134,
            column: 4
          },
          end: {
            line: 134,
            column: 27
          }
        }],
        line: 134
      },
      "15": {
        loc: {
          start: {
            line: 140,
            column: 78
          },
          end: {
            line: 140,
            column: 104
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 78
          },
          end: {
            line: 140,
            column: 89
          }
        }, {
          start: {
            line: 140,
            column: 93
          },
          end: {
            line: 140,
            column: 104
          }
        }],
        line: 140
      },
      "16": {
        loc: {
          start: {
            line: 142,
            column: 9
          },
          end: {
            line: 142,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 142,
            column: 28
          },
          end: {
            line: 142,
            column: 74
          }
        }, {
          start: {
            line: 142,
            column: 77
          },
          end: {
            line: 142,
            column: 81
          }
        }],
        line: 142
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Cascader/FilterList.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import absoluteList from '../AnimationList/AbsoluteList';
import { Component } from '../component';
import { getFlattenTree } from '../utils/tree';
import { selectClass } from '../Select/styles';
import { cascaderClass } from './styles';
import Spin from '../Spin';

var FilterItem =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterItem, _Component);

  var _super = _createSuper2(FilterItem);

  function FilterItem(props) {
    var _this;

    _classCallCheck(this, FilterItem);

    cov_10sngc5gms.f[0]++;
    cov_10sngc5gms.s[0]++;
    _this = _super.call(this, props);
    cov_10sngc5gms.s[1]++;
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_this));
    cov_10sngc5gms.s[2]++;
    _this.handleSelectItem = _this.handleSelectItem.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FilterItem, [{
    key: "checkDisabled",
    value: function checkDisabled(data) {
      cov_10sngc5gms.f[1]++;

      var _ref = (cov_10sngc5gms.s[3]++, this.props),
          datum = _ref.datum;

      var key = (cov_10sngc5gms.s[4]++, datum.getKey(data));
      cov_10sngc5gms.s[5]++;
      return datum.isDisabled(key);
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(index, e) {
      cov_10sngc5gms.f[2]++;

      var _ref2 = (cov_10sngc5gms.s[6]++, this.props),
          data = _ref2.data,
          datum = _ref2.datum,
          onChange = _ref2.onChange,
          onPathChange = _ref2.onPathChange,
          onFilter = _ref2.onFilter,
          filterText = _ref2.filterText,
          shouldFinal = _ref2.shouldFinal;

      var isFinal = (cov_10sngc5gms.s[7]++, (cov_10sngc5gms.b[0][0]++, data) && (cov_10sngc5gms.b[0][1]++, index === data.length - 1));
      cov_10sngc5gms.s[8]++;

      if ((cov_10sngc5gms.b[2][0]++, shouldFinal) && (cov_10sngc5gms.b[2][1]++, !isFinal)) {
        cov_10sngc5gms.b[1][0]++;
        cov_10sngc5gms.s[9]++;
        return;
      } else {
        cov_10sngc5gms.b[1][1]++;
      }

      cov_10sngc5gms.s[10]++;

      if (e) {
        cov_10sngc5gms.b[3][0]++;
        cov_10sngc5gms.s[11]++;
        e.stopPropagation();
      } else {
        cov_10sngc5gms.b[3][1]++;
      }

      var item = (cov_10sngc5gms.s[12]++, this.props.data[index]);
      cov_10sngc5gms.s[13]++;

      if (this.checkDisabled(item)) {
        cov_10sngc5gms.b[4][0]++;
        cov_10sngc5gms.s[14]++;
        return;
      } else {
        cov_10sngc5gms.b[4][1]++;
      }

      var keys = (cov_10sngc5gms.s[15]++, data.slice(0, index + 1).map(function (i) {
        cov_10sngc5gms.f[3]++;
        cov_10sngc5gms.s[16]++;
        return datum.getKey(i);
      }));
      cov_10sngc5gms.s[17]++;

      if (onChange) {
        cov_10sngc5gms.b[5][0]++;
        cov_10sngc5gms.s[18]++;
        onChange(keys);
      } else {
        cov_10sngc5gms.b[5][1]++;
      }

      cov_10sngc5gms.s[19]++;
      onPathChange(datum.getKey(item), item, keys.slice(0, keys.length - 1), true);
      cov_10sngc5gms.s[20]++;

      if ((cov_10sngc5gms.b[7][0]++, onFilter) && (cov_10sngc5gms.b[7][1]++, filterText)) {
        cov_10sngc5gms.b[6][0]++;
        cov_10sngc5gms.s[21]++;
        onFilter('');
      } else {
        cov_10sngc5gms.b[6][1]++;
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect() {
      cov_10sngc5gms.f[4]++;

      var _ref3 = (cov_10sngc5gms.s[22]++, this.props),
          data = _ref3.data;

      cov_10sngc5gms.s[23]++;
      this.handleSelectItem(data.length - 1);
    }
  }, {
    key: "renderItem",
    value: function renderItem(item) {
      cov_10sngc5gms.f[5]++;

      var _ref4 = (cov_10sngc5gms.s[24]++, this.props),
          renderItem = _ref4.renderItem;

      var render = (cov_10sngc5gms.s[25]++, renderItem);
      cov_10sngc5gms.s[26]++;

      if (typeof render === 'string') {
        cov_10sngc5gms.b[8][0]++;
        var copyRender = (cov_10sngc5gms.s[27]++, render);
        cov_10sngc5gms.s[28]++;

        render = function render(n) {
          cov_10sngc5gms.f[6]++;
          cov_10sngc5gms.s[29]++;
          return n[copyRender];
        };
      } else {
        cov_10sngc5gms.b[8][1]++;
      }

      cov_10sngc5gms.s[30]++;
      return render(item);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_10sngc5gms.f[7]++;

      var _ref5 = (cov_10sngc5gms.s[31]++, this.props),
          data = _ref5.data;

      cov_10sngc5gms.s[32]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: cascaderClass('node'),
          onClick: this.handleSelect,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 55,
            columnNumber: 7
          }
        }, data.map(function (item, i) {
          cov_10sngc5gms.f[8]++;
          var content = (cov_10sngc5gms.s[33]++,
          /*#__PURE__*/
          React.createElement("div", {
            onClick: _this2.handleSelectItem.bind(_this2, i),
            key: "content",
            className: cascaderClass('filter-list-content', (cov_10sngc5gms.b[9][0]++, _this2.checkDisabled(item)) && (cov_10sngc5gms.b[9][1]++, 'disabled')),
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 58,
              columnNumber: 13
            }
          }, _this2.renderItem(item)));
          cov_10sngc5gms.s[34]++;

          if (i === 0) {
            cov_10sngc5gms.b[10][0]++;
            cov_10sngc5gms.s[35]++;
            return content;
          } else {
            cov_10sngc5gms.b[10][1]++;
          }

          cov_10sngc5gms.s[36]++;
          return [
          /*#__PURE__*/
          React.createElement("span", {
            key: "separator",
            className: cascaderClass('filter-list-separator'),
            __self: _this2,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 68,
              columnNumber: 13
            }
          }, "/"), content];
        }))
      );
    }
  }]);

  return FilterItem;
}(Component); // eslint-disable-next-line react/no-multi-comp


var FilterList =
/*#__PURE__*/
function (_Component2) {
  _inherits(FilterList, _Component2);

  var _super2 = _createSuper2(FilterList);

  function FilterList() {
    _classCallCheck(this, FilterList);

    return _super2.apply(this, arguments);
  }

  _createClass(FilterList, [{
    key: "getKey",
    value: function getKey(path) {
      cov_10sngc5gms.f[9]++;

      var _ref6 = (cov_10sngc5gms.s[37]++, this.props),
          datum = _ref6.datum;

      cov_10sngc5gms.s[38]++;
      return path.map(function (d) {
        cov_10sngc5gms.f[10]++;
        cov_10sngc5gms.s[39]++;
        return datum.getKey(d);
      }).join('-');
    }
  }, {
    key: "getWideMatch",
    value: function getWideMatch(list) {
      cov_10sngc5gms.f[11]++;

      var _ref7 = (cov_10sngc5gms.s[40]++, this.props),
          filterDataChange = _ref7.filterDataChange;

      cov_10sngc5gms.s[41]++;
      return list.filter(function (arr) {
        cov_10sngc5gms.f[12]++;
        cov_10sngc5gms.s[42]++;
        return arr.some(function (item) {
          cov_10sngc5gms.f[13]++;
          cov_10sngc5gms.s[43]++;
          return filterDataChange(item);
        });
      });
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this3 = this;

      cov_10sngc5gms.f[14]++;

      var _ref8 = (cov_10sngc5gms.s[44]++, this.props),
          data = _ref8.data,
          childrenKey = _ref8.childrenKey,
          height = _ref8.height,
          loading = _ref8.loading,
          wideMatch = _ref8.wideMatch,
          others = _objectWithoutProperties(_ref8, ["data", "childrenKey", "height", "loading", "wideMatch"]);

      var list = (cov_10sngc5gms.s[45]++, getFlattenTree(data, childrenKey, wideMatch));
      cov_10sngc5gms.s[46]++;

      if (wideMatch) {
        cov_10sngc5gms.b[11][0]++;
        cov_10sngc5gms.s[47]++;
        list = this.getWideMatch(list);
      } else {
        cov_10sngc5gms.b[11][1]++;
      }

      cov_10sngc5gms.s[48]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: cascaderClass('filter-list'),
          style: {
            maxHeight: height
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 99,
            columnNumber: 7
          }
        }, loading ? (cov_10sngc5gms.b[12][0]++,
        /*#__PURE__*/
        React.createElement("div", {
          className: cascaderClass('list-loading'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 101,
            columnNumber: 11
          }
        }, typeof loading === 'boolean' ? (cov_10sngc5gms.b[13][0]++,
        /*#__PURE__*/
        React.createElement(Spin, {
          size: 20,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102,
            columnNumber: 45
          }
        })) : (cov_10sngc5gms.b[13][1]++, loading))) : (cov_10sngc5gms.b[12][1]++, list.map(function (path) {
          cov_10sngc5gms.f[15]++;
          cov_10sngc5gms.s[49]++;
          return (
            /*#__PURE__*/
            React.createElement(FilterItem, Object.assign({
              key: _this3.getKey(path)
            }, others, {
              data: path,
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 105,
                columnNumber: 28
              }
            }))
          );
        })))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_10sngc5gms.f[16]++;

      var _ref9 = (cov_10sngc5gms.s[50]++, this.props),
          focus = _ref9.focus,
          getRef = _ref9.getRef,
          fixed = _ref9.fixed,
          data = _ref9.data,
          childrenKey = _ref9.childrenKey,
          renderItem = _ref9.renderItem,
          datum = _ref9.datum,
          expandTrigger = _ref9.expandTrigger,
          onChange = _ref9.onChange,
          onPathChange = _ref9.onPathChange,
          filterText = _ref9.filterText,
          onFilter = _ref9.onFilter,
          wideMatch = _ref9.wideMatch,
          height = _ref9.height,
          filterDataChange = _ref9.filterDataChange,
          placeholder = _ref9.placeholder,
          renderOptionList = _ref9.renderOptionList,
          loading = _ref9.loading,
          shouldFinal = _ref9.shouldFinal,
          others = _objectWithoutProperties(_ref9, ["focus", "getRef", "fixed", "data", "childrenKey", "renderItem", "datum", "expandTrigger", "onChange", "onPathChange", "filterText", "onFilter", "wideMatch", "height", "filterDataChange", "placeholder", "renderOptionList", "loading", "shouldFinal"]);

      cov_10sngc5gms.s[51]++;

      if (!focus) {
        cov_10sngc5gms.b[14][0]++;
        cov_10sngc5gms.s[52]++;
        return null;
      } else {
        cov_10sngc5gms.b[14][1]++;
      }

      var list = (cov_10sngc5gms.s[53]++, this.renderList());
      cov_10sngc5gms.s[54]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, others, {
          ref: getRef,
          className: classnames(selectClass('options'), cascaderClass('filter', (cov_10sngc5gms.b[15][0]++, shouldFinal) && (cov_10sngc5gms.b[15][1]++, 'leaf-only'))),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 137,
            columnNumber: 7
          }
        }), renderOptionList ? (cov_10sngc5gms.b[16][0]++, renderOptionList(list, {
          loading: !!loading
        })) : (cov_10sngc5gms.b[16][1]++, list))
      );
    }
  }]);

  return FilterList;
}(Component); // @ts-ignore


export default absoluteList(FilterList);